<template>
    <div @scroll="changeIcon()">
        <div class="header">
            <commonHeader></commonHeader>
        </div>
        <div class="body">
            <router-view></router-view>
        </div>
        <div class="footer">
            <common-footer></common-footer>
        </div>
        <div class="icon_list" v-if="isShow">
            <a-popover   placement="left">
                <template slot="content">
                <div>027-87528232</div>
                </template>
                <img src="../assets/icon-phone.png" alt="">
            </a-popover>
            <a-popover  placement="left">
                <template slot="content" >
                    <div><img style="width:95px;height:95px;" src="../assets/qr1-1.png" alt=""></div>
                </template>
                <img src="../assets/icon-wechat.png" alt="">
            </a-popover>
            <img @click="scrollToTop()" src="../assets/icon-top.png" alt="">
        </div>
    </div>
</template>
<script>
import {Popover} from "ant-design-vue"
import commonHeader from '@/components/header'
import commonFooter from  '@/components/footer'
export default {
    name:'layout',
    mounted(){
        window.addEventListener('scroll', this.handleScroll)
    },
    data(){
        return{
            isShow:false
        }
    },
    components:{
        commonHeader,
        commonFooter,
        aPopover:Popover
    },
    methods:{
        handleScroll(){
            var scrollT = document.documentElement.scrollTop||document.body.scrollTop;
            var scrollH = document.documentElement.scrollHeight||document.body.scrollHeight;
            var clientH = document.documentElement.clientHeight||document.body.clientHeight
            if(scrollT>500){
                this.isShow=true
            }
            if(scrollT == scrollH - clientH){
                console.log("到底部了");
            }else if(scrollT == 0){
                this.isShow=false
            }
        },
        scrollToTop(){
            let scrollToptimer = setInterval(function () {
                var top = document.body.scrollTop || document.documentElement.scrollTop;
                var speed = top / 4;
                if (document.body.scrollTop!=0) {
                    document.body.scrollTop -= speed;
                }else {
                    document.documentElement.scrollTop -= speed;
                }
                if (top == 0) {
                    clearInterval(scrollToptimer);
                }
            }, 30); 
        }
    }
}
</script>
<style lang="stylus" scoped>
.icon_list
    position:fixed;
    bottom:50px;
    right:30px;
    display:flex;
    flex-direction:column;
    z-index:3;
    img 
        margin-bottom:10px;
        cursor:pointer;
</style>